<template>
  <TemplateShelterDetail v-if="page" :breadcrumbs="breadcrumbs" :page="page" :animal-counts="animalCounts" />
</template>

<script setup lang="ts">
import { getIndirectClientHeaders, seoHead } from '~/assets/seo'
import { getBreadcrumbs, getSiteConfig } from '~/composables/craft'
import { useSeoRedirect } from '~/composables/seo-redirect'
import { setCacheControlHeader, setPageCacheControlHeader } from '~/composables/util'
import { useNavigationStore } from '~/store/navigation'
import { useGlobalStore } from '~/store/global'
import { usePageStore } from '~/store/page'
import { useAnimalStore } from '~/store/animal'

/** Routes will be split on the '~~' characters {@see nuxt/app/router.options.ts} */
false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    nl: '/ikzoekbaas/afdelingen/[departmentTypeSlug]/[siteSlug]~~/mijndieriszoek/afdelingen/[departmentTypeSlug]/[siteSlug]',
  },
})

const route = useRoute()
const navigationStore = useNavigationStore()
const globalStore = useGlobalStore()
const pageStore = usePageStore()
const animalStore = useAnimalStore()
const seoRedirect = useSeoRedirect()
let page = null
let breadcrumbs = null
let animalCounts = null

const { domain, site, siteSlug } = getSiteConfig(route)

if (siteSlug === undefined) {
  setCacheControlHeader(600, true)
  const redirect = await seoRedirect(site, route.fullPath)
  if (redirect === false) {
    throw createError({ statusCode: 404, message: 'Page not found' })
  }
} else {
  const [, seoGlobal, page_, animalCounts_] = await Promise.all([
    navigationStore.fetch(site),
    globalStore.fetchSeo(),
    pageStore.fetchUri({ site, uri: `/detail-redirect`, push: true, options: { headers: getIndirectClientHeaders() } }),
    animalStore.fetchAnimalCounts(site, domain === 'ikZoekBaas' ? 'available' : 'found'),
  ])
  page = page_
  animalCounts = animalCounts_

  if (!page) {
    setCacheControlHeader(600, true)
    const redirect = await seoRedirect(site, route.fullPath)
    if (redirect === false) {
      throw createError({ statusCode: 404, message: 'Page not found', fatal: true })
    }
  } else if (route.path.endsWith('/')) {
    /**
     * [DB-748] This URL format is defined by Nuxt (the CMS is only queried by `[siteSlug]`), so
     * Nuxt must canonicalize a trailing slash itself: redirect to the URL without it, keeping the
     * query string.
     */
    setCacheControlHeader(600, true)
    await navigateTo(route.path.replace(/\/+$/, '') + route.fullPath.slice(route.path.length), { redirectCode: 301, replace: true })
  } else {
    breadcrumbs = getBreadcrumbs(route, page)

    setPageCacheControlHeader(page)

    useHead(() => seoHead(page, seoGlobal))
  }
}
</script>
